'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _error = require('redux/actions/error');

var _reactRouterRedux = require('react-router-redux');

var _modal = require('redux/actions/modal');

var _modal_type = require('redux/actions/modal_type');

var _LocalStorageProxy = require('ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

var _utils = require('helpers/utils');

var _IBonusError = require('api/IBonusError');

var _IBonusError2 = _interopRequireDefault(_IBonusError);

var _basket = require('redux/actions/basket');

var _copyToClipboard = require('copy-to-clipboard');

var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _helpers = require('helpers');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Basket: {
        displayName: 'Basket'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Basket/Basket.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ALCO_TYPES = {
    LOW_ALCOHOL: 3,
    ALCOHOL: 2,
    NO_ALCOHOL: 1
};

var Basket = _wrapComponent('Basket')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        basketElements: state.basket.items,
        cartDescription: state.setting.cartDescription,
        cartSubject: state.setting.cartSubject,
        channelId: state.setting.channelId,
        dataError: state.basket.dataError,
        isCopedItems: state.basket.is_coped_items,
        logo: state.setting.logo,
        preload: state.basket.preload,
        profileId: state.setting.profileId,
        shareCode: state.basket.shareCode,
        sharePreload: state.basket.sharePreload,
        actualPricesPreload: state.basket.actualPricesPreload,
        showShare: state.basket.showShare,
        user: state.auth.user,
        orderInOneClick: state.setting.orderInOneClick,
        lang: state.lang,
        currency: state.currency,
        customFields: state.setting.customFields,
        fieldsShare: state.basket.fields
    };
}, {
    changeCountProduct: _basket.changeCountProduct,
    changeShareState: _basket.changeShareState,
    clearBasket: _basket.clearBasket,
    createOrder: _basket.createOrder,
    editOrder: _basket.editOrder,
    deleteProduct: _basket.deleteProduct,
    error: _error.error,
    hide: _modal.hide,
    push: _reactRouterRedux.push,
    resetShareCode: _basket.resetShareCode,
    shareBasket: _basket.shareBasket,
    showAlcoModal: _modal_type.showAlcoModal,
    showModal: _modal.showModal,
    showModalAuth: _modal_type.showModalAuth,
    showModalAuthOneClick: _modal_type.showModalAuthOneClick,
    postponeBasket: _basket.postponeBasket
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Basket, _Component);

    function Basket(props) {
        (0, _classCallCheck3.default)(this, Basket);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Basket.__proto__ || (0, _getPrototypeOf2.default)(Basket)).call(this));

        _this.onDelete = function (id) {
            var modifier_option_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var lang = _this.props.lang;


            var modalContent = _react3.default.createElement(
                'div',
                { className: 'row no-margin' },
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12' },
                    lang['store.cart.on_delete.confirmation']
                )
            );

            _this.props.showModal({
                title: lang['store.cart.on_delete.title'],
                content: modalContent,
                titleSuccess: lang['store.common.yes'],
                titleClose: lang['store.common.no'],
                onSuccess: function onSuccess() {
                    _this.props.deleteProduct(id, modifier_option_id, key);
                    // this.props.dataError = null;
                },
                modalType: 'del'
            });
        };

        _this.onChangeCount = function (productId, newCount) {
            var modifier_option_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            _this.props.changeCountProduct(productId, newCount, modifier_option_id, key);
        };

        _this.onCreateOrder = function () {
            // проверим авторизацию пользователя
            if (_this.props.user) {
                if (_this.state.editOrderId) {
                    _this.callEditOrder();
                } else {
                    _this.callCreateOrder();
                }
            } else {
                if (_this.props.orderInOneClick) {
                    _this.props.showModalAuthOneClick();
                } else {
                    _this.props.showModalAuth(_this.props.lang);
                }
                _this.setState({ wasOrderClick: true });
            }
        };

        _this._removeAlcoElements = function () {
            var alcoId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var products = [];

            _this.props.basketElements.forEach(function (item) {
                if (alcoId.includes(item.id)) {
                    _this.props.deleteProduct(item.id);
                } else {
                    products.push(item);
                }
            });

            return products;
        };

        _this._compileOrder = function () {
            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var sum = 0;
            var products = [];
            basketElements.map(function (element) {
                sum += element.price * element.count;
                products.push({
                    offer_id: element.id,
                    quantity: element.count,
                    price: element.price,
                    modifier_option_id: element.modifier_option_id,
                    modifier_option_name: element.modifier_option_name,
                    custom_fields: element.custom_fields,
                    nestedOffers: element.nested_offer,
                    coupon_id: element.coupon_id, coupon_token: element.coupon_token, customer_coupon_id: element.customer_coupon_id,
                    basket_number: element.basket_number
                });
            });
            if (sum < 1) {
                var alertMessage = (0, _utils.replaceCharToArrayIndex)(_this.props.lang['error.pipo.operationInvalidMinimalSum'], [_this.props.currency.code]);
                setTimeout(function () {
                    _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                }, 0);
                throw new _IBonusError2.default({
                    message: alertMessage,
                    title: alertMessage,
                    code: '',
                    trace: ''
                });
            }
            var userAgent = navigator.userAgent || '';
            var utmRedirectData = _LocalStorageProxy2.default.getItem('utm_redirect_data') || '';
            var customFields = _this.state.customFields || [];
            _LocalStorageProxy2.default.setItem('utm_redirect_data', '');

            var currency_id = _this.props.currency.id;

            if (_this.state.editOrderId) {
                var order_id = _this.state.editOrderId;
                return { order_id: order_id, sum: sum, products: products, userAgent: userAgent, utmRedirectData: utmRedirectData, currency_id: currency_id, customFields: customFields };
            }
            return { sum: sum, products: products, userAgent: userAgent, utmRedirectData: utmRedirectData, currency_id: currency_id, customFields: customFields };
        };

        _this._showAlcoWarning = function () {
            var alcoId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var lang = _this.props.lang;


            var modalContent = _react3.default.createElement(
                'div',
                null,
                lang['store.cart.alco_warning.confirmation']
            );

            var confirmModal = function confirmModal() {
                _this.props.showModal({
                    title: lang['store.modals.alcohol_removal'],
                    content: modalContent,
                    titleSuccess: lang['store.common.yes'],
                    titleClose: lang['store.common.cancel'],
                    onSuccess: function onSuccess() {
                        if (_this.state.editOrderId) {
                            _this.callEditOrder(_this._removeAlcoElements(alcoId));
                        } else {
                            _this.callCreateOrder(_this._removeAlcoElements(alcoId));
                        }
                    },
                    modalType: 'del'
                });
            };

            if (alcoId.length > 0) {
                _this.props.showAlcoModal(confirmModal, lang);
            }
        };

        _this.callCreateOrder = function () {
            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.basketElements;

            if (basketElements.length > 0) {
                _this.props.createOrder(_this._compileOrder(basketElements)).then(function (result) {
                    _this.props.clearBasket();
                    _this.props.push('/create-order/' + result.result.order_id);
                }).catch(function (err) {
                    //Ошибка "предложение не найдено"
                    if (err.code === 139 && err.title === 'error.catalogOfferNotFind') {
                        console.log('предложение не найдено', err);
                        err.dataError.forEach(function (item) {
                            _this.props.deleteProduct(item);
                        });

                        var alertMessage = _this.props.lang['store.cart.call_create_order.catalog_offer_not_found'];

                        setTimeout(function () {
                            _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                        }, 0);
                    }

                    //Ошибка: алкогольные товары в корзине
                    if (err.code === 136 && err.title === 'error.orderExciseMarkBarcodeIsRequired') {
                        _this._showAlcoWarning(err.dataError);
                    }
                });
            }
        };

        _this.callEditOrder = function () {
            var basketElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.basketElements;

            if (basketElements.length > 0) {
                _this.props.editOrder(_this._compileOrder(basketElements)).then(function (result) {
                    _this.props.clearBasket();
                    _LocalStorageProxy2.default.removeItem('basket.edit_order_number');
                    _LocalStorageProxy2.default.removeItem('basket.edit_order_id');
                    _this.setState({ editOrderNumber: null });
                    _this.setState({ editOrderId: null });
                    _this.props.push('/create-order/' + result.result.order_id);
                }).catch(function (err) {
                    //Ошибка "предложение не найдено"
                    if (err.code === 139 && err.title === 'error.catalogOfferNotFind') {
                        console.log('предложение не найдено', err);
                        err.dataError.forEach(function (item) {
                            _this.props.deleteProduct(item);
                        });

                        var alertMessage = _this.props.lang['store.cart.call_create_order.catalog_offer_not_found'];

                        setTimeout(function () {
                            _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                        }, 0);
                    }

                    //Ошибка: алкогольные товары в корзине
                    if (err.code === 136 && err.title === 'error.orderExciseMarkBarcodeIsRequired') {
                        _this._showAlcoWarning(err.dataError);
                    }
                });
            }
        };

        _this.handleDelayedBasket = function () {
            _this.props.postponeBasket(_this.props.basketElements, _this.state.customFields).then(function (result) {
                _this.props.clearBasket();
                _this.props.push('/postpone');
            });
        };

        _this.handleShareBasket = function () {
            if (!_this.props.shareCode) {
                _this.props.shareBasket(_this.props.basketElements, _this.state.customFields);
            } else {
                _this.props.changeShareState(true);
            }
        };

        _this.handleHideShare = function () {
            _this.props.changeShareState(false);
        };

        _this.changeCustomFields = function (e) {
            if (_this.props.customFields[e.target.id].type === 'text') {
                _this.props.customFields[e.target.id].value = e.target.value;
            } else {
                _this.props.customFields[e.target.id].value = e.target.checked;
            }
            // this.props.customFields[e.target.id].value = e.target.value;
            _this.setState({ customFields: _this.props.customFields });
            // this.props.shareCode = null;
            _this.props.changeShareState(false);
        };

        _this.handleCopyToBuffer = function () {
            (0, _copyToClipboard2.default)(global.location.origin + '/basket/' + _this.props.shareCode);
            var alertMessage = _this.props.lang['store.common.link_copied'];
            setTimeout(function () {
                _reactSAlert2.default.success(alertMessage, { position: 'top-right', effect: 'slide', timeout: 5000 });
            }, 0);
        };

        _this.cancelEditOrder = function () {
            _LocalStorageProxy2.default.removeItem('basket.edit_order_number');
            _LocalStorageProxy2.default.removeItem('basket.edit_order_id');
            _this.setState({ editOrderNumber: null });
            _this.setState({ editOrderId: null });
        };

        var fields = props.customFields;
        if (props.fieldsShare !== undefined && props.fieldsShare.length > 0) {
            fields = props.fieldsShare;
        }
        _this.state = {
            wasOrderClick: false,
            editOrderNumber: _LocalStorageProxy2.default.getItem('basket.edit_order_number'),
            editOrderId: _LocalStorageProxy2.default.getItem('basket.edit_order_id'),
            customFields: fields
        };
        return _this;
    }

    (0, _createClass3.default)(Basket, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            if (this.state.wasOrderClick && !!nextProps.user && !this.props.user) {
                if (this.state.editOrderId) {
                    this.callEditOrder();
                } else {
                    this.callCreateOrder();
                }
                this.setState({ wasOrderClick: false });
                return false;
            }

            if (this.state.wasOrderClick) {
                this.setState({ wasOrderClick: false });
            }

            return true;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.changeShareState(false);
        }
    }, {
        key: 'render',
        value: function render() {
            var basketElements = this.props.basketElements || [];
            var View = _helpers.ThemeHelper.getViewForComponent('Basket');

            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload || !this.props.isCopedItems || this.props.actualPricesPreload },
                _react3.default.createElement(View, {
                    before: this.props.before,
                    copyToBuffer: this.handleCopyToBuffer,
                    elements: basketElements,
                    dataError: this.props.dataError,
                    logo: this.props.logo,
                    onDelete: this.onDelete,
                    onChangeCount: this.onChangeCount,
                    onCreateOrder: this.onCreateOrder,
                    user: this.props.user,
                    cartSubject: this.props.cartSubject,
                    cartDescription: this.props.cartDescription,
                    shareBasket: this.handleShareBasket,
                    hideShare: this.handleHideShare,
                    showShare: this.props.showShare,
                    shareCode: this.props.shareCode,
                    sharePreload: this.props.sharePreload,
                    lang: this.props.lang,
                    currency: this.props.currency,
                    editOrderNumber: this.state.editOrderNumber,
                    cancelEditOrder: this.cancelEditOrder,
                    customFields: this.state.customFields,
                    changeCustomFields: this.changeCustomFields,
                    postponeBasket: this.handleDelayedBasket
                })
            );
        }
    }]);
    return Basket;
}(_react2.Component), _class2.propTypes = {
    basketElements: _react2.PropTypes.array.isRequired,
    changeCountProduct: _react2.PropTypes.func.isRequired,
    deleteProduct: _react2.PropTypes.func.isRequired,
    isCopedItems: _react2.PropTypes.bool,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _class2.defaultProps = {
    basketElements: [],
    isCopedItems: false,
    user: null
}, _temp)) || _class));

exports.default = Basket;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Basket/Basket.jsx
// module id = 747
// module chunks = 0